<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex';
import { notificationCheckTime } from '@/app.config';

export default {
  name: 'NotificationDisplayManager',
  props: { isInactive: Boolean },
  data() {
    return {
      isPolling: false,
      isFetching: false,
      fetchRequestedWhileBusy: false,
      notificationTimeoutHandle: null,
      checkTime: 0,
    };
  },
  computed: {
    ...mapGetters('client', ['hasClient']),
  },
  watch: {
    isInactive(nowInactive) {
      // The user going idle intentionally stops polling below; nothing else ever restarts it
      // when they come back, so do that here rather than leaving it dead until a page reload.
      if (!nowInactive) {
        this.handleFetchNotifications();
      }
    },
    hasClient(nowHasClient) {
      // This component mounts at the App level, before the client entity has necessarily
      // loaded, so the created() call below can no-op (fetchClientNotifications early-returns
      // without one). Fire again the moment a client becomes available instead of waiting out
      // the rest of the poll interval.
      if (nowHasClient) {
        this.handleFetchNotifications();
      }
    },
  },
  created() {
    this.isPolling = true;
    this.handleFetchNotifications();
  },
  beforeUnmount() {
    if (this.notificationTimeoutHandle) {
      clearTimeout(this.notificationTimeoutHandle);
    }

    this.isPolling = false;
  },
  methods: {
    handleFetchNotifications() {
      if (this.notificationTimeoutHandle) {
        clearTimeout(this.notificationTimeoutHandle);
        this.notificationTimeoutHandle = null;
      }

      if (!this.isPolling || this.isInactive) {
        return;
      }

      if (this.isFetching) {
        // A fetch is already in flight (e.g. created() and a watcher firing back-to-back before
        // the first dispatch resolves). Don't start a second overlapping one - each completion
        // would otherwise schedule its own timer, leaving one of them untracked and running a
        // duplicate poll loop. Re-run once the in-flight one finishes instead.
        this.fetchRequestedWhileBusy = true;
        return;
      }

      this.isFetching = true;

      this.$store
        .dispatch('notifications/fetchClientNotifications')
        .catch(err => {
          // A failure here must not permanently kill the poll loop.
          console.error(err);
        })
        .then(() => {
          this.isFetching = false;

          if (this.fetchRequestedWhileBusy) {
            this.fetchRequestedWhileBusy = false;
            this.handleFetchNotifications();
            return;
          }

          // Re-check rather than trusting the state from before this dispatch started - the
          // component may have gone inactive or unmounted while the request was in flight.
          if (!this.isPolling || this.isInactive) {
            return;
          }

          this.notificationTimeoutHandle = setTimeout(() => {
            this.checkTime = notificationCheckTime;
            this.handleFetchNotifications();
          }, this.checkTime);
        });
    },
  },
};
</script>
